
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies",
      function () {
        return require("private-next-pages/companies/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies"])
      });
    }
  